document.addEventListener('DOMContentLoaded', function() {
  var backToTopButton = document.getElementById('back-to-top');

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 300) { // Show button after scrolling 300px
      backToTopButton.classList.add('show');
    } else {
      backToTopButton.classList.remove('show');
    }
  });

  backToTopButton.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
});


/* スクロールに応じて要素をフェードイン
----------------------- */
document.addEventListener('DOMContentLoaded', function() {
  // アニメーションを実行する関数
  function animateOnScroll() {
    var windowHeight = window.innerHeight;
    var topWindow = window.pageYOffset;

    // .animクラスの各要素について処理
    document.querySelectorAll('.anim').forEach(function(element) {
      var animClass = element.getAttribute('data-label');

      // まだアニメーションが実行されていない場合のみ処理
      if (!element.classList.contains('animated')) {
        // 要素の文書上での上端位置を算出
        var targetPosition = element.getBoundingClientRect().top + window.pageYOffset;

        // ウィンドウ下部から150px以内に要素が来たらアニメーションを開始
        if (topWindow > targetPosition - windowHeight + 150) {
          element.classList.add('animated');
          if (animClass) {
            element.classList.add(animClass);
          }
        }
      }
    });
  }

  // ページ読み込み、スクロール、リサイズ時にanimateOnScrollを実行
  window.addEventListener('load', animateOnScroll);
  window.addEventListener('scroll', animateOnScroll);
  window.addEventListener('resize', animateOnScroll);
});

